import { ClientLogger } from 'bernie-client';
import type { ClientFactories, Store } from 'bernie-plugin-mobx';

import { TemplateStore } from './template-store';

export const stores: ClientFactories = {
  template: ({ bexApiContext }): Store =>
    new TemplateStore({}, ClientLogger.getLoggerWithIdentifier('pwa.store.template'), bexApiContext.locale, {}, false)
};
